import React from 'react'

function AngleBracketRight() {
  return (
    <div>
      <svg width="16px" height="16px" viewBox="0 0 1024 1024" data-aut-id="icon" class="" fill-rule="evenodd"><path class="rui-32D-k" d="M277.333 85.333v60.331l366.336 366.336-366.336 366.336v60.331h60.331l409.003-408.981v-35.307l-409.003-409.045z"></path></svg>
    </div>
  )
}

export default AngleBracketRight
